import { useEffect } from 'react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

/**
 * ConsumerLayout - Shared wrapper for all consumer-facing pages.
 * Provides consistent Navigation, Footer, and optional dark theme.
 */
const ConsumerLayout = ({ children, className = '', darkTheme = false, hideFooter = false }) => {
  useEffect(() => {
    if (darkTheme) {
      document.documentElement.classList.add('consumer-dark');
      document.body.classList.add('consumer-dark');
    }
    return () => {
      document.documentElement.classList.remove('consumer-dark');
      document.body.classList.remove('consumer-dark');
    };
  }, [darkTheme]);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`min-h-screen ${darkTheme ? 'bg-[#0f172a] text-slate-50' : 'bg-background'} ${className}`}>
      <Navigation />
      {children}
      {!hideFooter && <Footer />}
    </div>
  );
};

export default ConsumerLayout;
